import * as components from './components'

export default [
  {
    path: '/sharing',
    component: components.Sharing,
    name: 'sharing',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/sharing/routes.js